<script>
/** Utilities */
import * as jsPDF from 'jspdf'
import 'jspdf-autotable'; // https://github.com/simonbengtsson/jsPDF-AutoTable
import JsonCSV from 'vue-json-csv';
import JsonExcel from 'vue-json-excel'
import { mapState,mapMutations } from 'vuex';
import ArrayUtil from '../../utilities/ArrayUtil'
import BrowserDataUtil from '../../utilities/BrowserDataUtil'
import AppResourceUtil from '../../utilities/AppResourceUtil'
/** Constants */
import ReportColumns from '../../constants/ReportColumns'
/**  API */
import UserApi from '../../api/UserApi'
import IssueApi from '../../api/IssueApi'
import ValidationCardApi from '../../api/ValidationCardApi'
import ReportingGroupApi from '../../api/ReportingGroupApi'
import FormsApi from '../../api/FormsApi'
import ReportApi from '../../api/ReportApi'
/** UI Components */
import { Checkbox } from 'buefy/dist/components/checkbox'
import { Collapse } from 'buefy/dist/components/collapse'
import { Dropdown, DropdownItem } from 'buefy/dist/components/dropdown'
import { Icon } from 'buefy/dist/components/icon'
import { Field } from 'buefy/dist/components/field'
import { Select } from 'buefy/dist/components/select'
import { Loading } from 'buefy/dist/components/loading'
import { Radio } from 'buefy/dist/components/radio'
import { Message } from 'buefy/dist/components/message'
import { Switch } from 'buefy/dist/components/switch'

const FOOTER_TEXT = "PH-EITI - Online Reporting in the Extractives "

export default {
    name : "ReportsView",
    components : {
        'b-checkbox' : Checkbox,
        'b-collapse' : Collapse,
        'b-field' : Field,
        'b-icon' : Icon,
        'b-select' : Select,
        'b-loading' : Loading,
        'b-radio' : Radio,
        'b-message' : Message,
        'b-dropdown' : Dropdown,
        'b-dropdown-item' : DropdownItem,
        'b-switch' : Switch,
        'download-csv' : JsonCSV,
        'download-excel' : JsonExcel
    },
    data(){
        return {
            requiredColumns : ReportColumns.required,
            selectedReportingYear : null,
            selectedRepGroup : null,
            companies : [],
            openRepYearLov : true,
            openRepGroupsLov : true,
            forms : [],
            selectedReportColumns : [],
            isLoading : false,
            generatedRows : [],
            csvFileName : "",
            csvFieldColumns : [],
            csvFieldLabels : {},
            csvFieldLabelsOpp : {},
            csvDataRows : [],
            isGrouped : false,
            isGroupingApplicable : false
        }
    },
    computed : {
        ...mapState({
            profile : "userProfile",
            token : "xOreAuth"
        }),
        checkedRepGroups(){
            let selectedGrps = [];
            if (this.companies.length > 0) {
                this.companies.forEach(grp=>{
                    if (grp.checked == true) {
                        selectedGrps.push(grp.reportingGroup)
                    }
                })
            }
            return selectedGrps;
        },
        checkedRepGroupIds(){
            let selectedGrpIds = [];
            if (this.companies.length > 0) {
                this.companies.forEach(grp=>{
                    if (grp.checked == true) {
                        selectedGrpIds.push(grp.reportingGroupId)
                    }
                })
            }
            return selectedGrpIds;
        },
        groupedForms(){
            let groupings = [], 
                newGroupings = [], 
                finalGroupings = [];

            if (this.forms.length > 0) {
                this.forms.forEach(vform=>{
                    if (ArrayUtil.inArray(groupings,vform.groupLabelName)==false) {
                        groupings.push(vform.groupLabelName)
                    }
                });
                //////////
                groupings.forEach(grpName=>{
                    newGroupings.push({
                        groupLabelName : grpName,
                        forms: []
                    });
                    this.forms.forEach(vcardForm=>{
                        if (vcardForm.groupLabelName==grpName) {
                            newGroupings[newGroupings.length-1].forms.push(vcardForm);
                        }
                    });
                });

                if (newGroupings.length > 0) {

                    if (this.selectedRepGroup) {

                        // let selectedGrps = this.checkedRepGroups;
                        newGroupings.forEach(grp=>{
                            grp.filteredForms = [];
                            if (grp.forms.length > 0) {
                                
                                grp.forms.forEach(gForm=>{

                                    // Check each form rep group access is in
                                    // selected rep group

                                    if (gForm.formAccessData.reportingGroups) {

                                        let result = gForm.formAccessData.reportingGroups.filter(repGrpAccess=>{
                                            return (repGrpAccess.repGroupIdFk==this.selectedRepGroup)
                                        });

                                        if (result.length > 0) {
                                            grp.filteredForms.push(gForm);
                                        }

                                        /* For checkbox implementation

                                        let hasRepGroupAccess = false;
                                        this.checkedRepGroups.forEach(rgrp=>{
                                            let accessRes = gForm.formAccessData.reportingGroups.filter(repGrpAccess=>{
                                                return (repGrpAccess.reportingGroup==rgrp)
                                            });
                                            if (accessRes.length > 0) {
                                                hasRepGroupAccess = true;
                                            }
                                        }) 
                                        if (hasRepGroupAccess==true) {
                                            grp.filteredForms.push(gForm);
                                        }
                                        */
                                        
                                        
                                        
                                    }

                                });
                            }
                        })

                    }
                }
            }
            return newGroupings;
        },
        notRecommendedForPdf(){
            if (this.selectedReportColumns.length > 11) {
                return true;
            }
            return false;
        }
    },
    created(){
        if (!this.profile) {
            this.clearSession();
            return false;
        }
        // this.isTokenValid();
        // get reporting year 
        this.getReportingYearLov();
        this.getReportingGroups();
    },
    methods : {
        ...mapMutations({
            clearAppData : "clearAppData"
        }),
        isTokenValid(){
            if (!this.token) {
                this.clearSession();
                return false
            }
            UserApi.isTokenValid({
                token : this.token
            })
            .then(response=>{
                if (response.data){
                    if (response.data.length > 0) {
                        let data = response.data[0];
                        if (data.dateCreated) {
                            let a = this.$moment();
                            let b = this.$moment(data.dateCreated,'YYYY-MM-DD HH:mm:ss');
                            let duration = a.diff(b, 'days');
                            if (duration >= 1 ) {
                                // Session is expired
                                this.logOut()
                            }
                            else {
                                // Session is still active
                                // Default call in created
                            }
                        }
                    }
                    else {
                        if (response.data.hasOwnProperty('error')) {
                            this.promptServerError({response},'User.isSessionValid');
                            return false;
                        }
                        this.logOut();
                        return false;
                    }
                } 
            })
            .catch(error=>{
                this.promptServerError(error,'User.isSessionValid');
            });
        },
        logOut(){   
            if (this.token) {
                let data = {
                    token : this.token
                }
                if (this.profile) {
                    data.userIdFk = this.profile.userId
                }
                // End session from back-end
                UserApi.endSession(data)
                .then(response=>{
                    if (response.data) {
                        if (response.data.isDeleted) {
                            this.clearSession();
                        }
                    }
                })
                .catch(error=>{
                })
            }
            else {
                // Remove session data from client-side
                this.clearSession();
            }
        },
        clearSession(){
            BrowserDataUtil.clearBrowserData(this.$cookies);
            this.clearAppData();
            this.$router.push({path:"/login"})
        },
        getReportingYearLov(vcardId){
            this.isLoading = true;
            this.reportingYearLov = [];
            this.selectedReportColumns = [];

            ValidationCardApi.getReportingYearLov()
            .then(response=>{
                let repYearInDb = [];
                if (response.data) {
                    if (!response.data.error) {

                        if (response.data.length > 0) {
                            repYearInDb = response.data.map(yr=>{
                                return (yr.reportingYear);
                            });
                        }

                        /* Sort the years in descending order */ 
                        this.reportingYearLov = repYearInDb.sort().reverse();

                        if (this.reportingYearLov.length > 0) {
                            this.selectedReportingYear = this.reportingYearLov[0];
                            this.initColumns();
                            this.getForms();
                        }
                        else {
                            this.isLoading = false;
                        }
                    }
                    else {
                        this.isLoading = false;
                        this.promptServerError({response},'ValidationCard.getReportingYearLov');
                    }
                }
            })
            .catch(error=>{
                this.isLoading = false;
                this.promptServerError(error,'ValidationCard.getReportingYearLov');
            });
        },
        getReportingGroups(){
            this.isLoading = true;
            this.companies = [];

            ReportingGroupApi.getAllData()
            .then(response => {
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.length > 0) {
                            let repGroups = response.data;
                            this.companies = repGroups.filter(grp=>{
                                grp.checked = true;
                                // return grp.reportingGroup!='Government Agencies'
                                return grp.reportingGroup
                            });
                            // For checkbox implementation
                            // this.selectedReportColumns.push({
                            //     label : "Agency/Company Name",
                            //     value: "reportingGroup",
                            //     filterValue : this.checkedRepGroups.join(","),
                            //     valueType : "reportingGroup",
                            //     ids : this.checkedRepGroupIds
                            // })
                        }
                    }
                    else {
                        this.promptServerError({response},'ReportingGroup.getAllGroupData');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'ReportingGroup.getAllGroupData');
            });
        },
        selectYear(){
            if (!this.selectedReportingYear) {
                return false
            }
            this.resetParameters();
            this.initColumns();
            this.getForms();
        },
        getForms(){
            this.isLoading = true;
            this.forms = [];
            // With back-end integration
            FormsApi.getAllActive({
                reportingYear : this.selectedReportingYear
            })
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        let forms = response.data;
                        forms.forEach(form=>{
                            form.isOpen = false
                            // let adata = this.setOtherAccessData(form);
                            // form.formAccessDataNameList = adata.list;
                            // form.formAccessDataStr = adata.str;
                        });
                        this.forms = forms;
                        // set store data - forms
                        this.isLoading = false;
                    }
                    else {
                        this.isLoading = false;
                        this.promptServerError({response},'Form.getAll');
                    }
                }
            })
            .catch(error=>{
                this.isLoading = false;
                this.promptServerError(error,'Form.getAll');
            });
        },
        getGroupedForms(){
            this.groupedForms = [];

            let groupings = [], newGroupings = [];
            if (this.forms.length > 0) {
                this.forms.forEach(vform=>{
                    if (ArrayUtil.inArray(groupings,vform.groupLabelName)==false) {
                        groupings.push(vform.groupLabelName)
                    }
                });
                //////////
                groupings.forEach(grpName=>{
                    newGroupings.push({
                        groupLabelName : grpName,
                        forms: []
                    });
                    this.forms.forEach(vcardForm=>{
                        if (vcardForm.groupLabelName==grpName) {
                            newGroupings[newGroupings.length-1].forms.push(vcardForm);
                        }
                    });
                });
            }

            this.groupedForms = newGroupings;
        },
        addAllFields(form){
            if (form.formFields && form.formFields.length) {
                form.formFields.forEach(field => {
                    this.addToColumns('formField',field,true)
                })
            }
        },
        addToColumns(fieldType,field,selected){
            if (fieldType=='formField') {
                var fieldLabel = field.fieldLabel
                if (field.fieldGroupLabel !== '' && field.fieldGroupLabel !== null ) {
                    fieldLabel = `${field.fieldGroupLabel} - ${field.fieldLabel}`
                }
                if (field.fieldSubLabel !== '' && field.fieldSubLabel !== null) {
                    fieldLabel += ' '+field.fieldSubLabel
                }
                this.selectedReportColumns.push({
                    label : fieldLabel,
                    value: field.fieldId,
                    filterValue : field.fieldId,
                    valueType : "fieldId"
                });

                // Add to csv fields
                this.csvFieldColumns.push('fieldId-'+field.fieldId);
                
                // Add to csv field labels
                this.csvFieldLabels['fieldId-'+field.fieldId] = fieldLabel.trim();
                
                this.csvFieldLabelsOpp[fieldLabel.trim()] = 'fieldId-'+field.fieldId;
            }
        },
        inColumns(fieldType,fieldId) {
            if (fieldType=='formField') {
                let res = this.selectedReportColumns.filter(col=>{
                    return col.filterValue==fieldId
                });
                if (res.length > 0) {
                    return true;
                }
                return false;
            }
        },
        removeColumn(fieldType,field,selected) {
            if (this.generatedRows.length > 0) {
                this.$dialog.confirm({
                    title: 'Warning',
                    message: "There's data displayed on the table. Do you wish to reset/change the columns?",
                    cancelText: "Don't Reset",
                    confirmText: 'Reset Columns',
                    type: 'is-warning',
                    onConfirm: () => {
                        this.generatedRows = [];
                        if (fieldType=='formField' && selected==false) {
                            let idx = ArrayUtil.getIndex(this.selectedReportColumns,'value',field.fieldId);
                            if (idx!=null) {
                                this.selectedReportColumns.splice(idx,1);
                            }
                        }
                    }
                });
            }
            else {
                // No prompt
                if (fieldType=='formField' && selected==false) {
                    let idx = ArrayUtil.getIndex(this.selectedReportColumns,'value',field.fieldId);
                    if (idx!=null) {
                        this.selectedReportColumns.splice(idx,1);
                    }
                }
            }
        },
        generateReport(){
            if (this.selectedReportColumns.length == 0) {
                return false
            }
            this.csvFileName = 'ORE_Custom-Report_'+this.$moment().format('x');
            /** 
             * Get reporting year -> reportingYear : 2018
                reportingGroupId in (1,2,..,3) 
            */
            if (!this.selectedRepGroup) {
                return false
            }
            
            let formFields = this.selectedReportColumns.filter(col=>{
                return col.valueType=='fieldId'
            });
            let fieldIds = [];
            if (formFields.length > 0) {
                fieldIds = formFields.map(field=>{
                    return field.value;
                });
            }
            let paramData = {
                reportingYear : this.selectedReportingYear,
                repGroupIdFk : this.selectedRepGroup,
                formFields,
                fieldIds
            }

            this.generatedRows = [];
            //this.groupedCsvRows = [];

            this.csvDataRows = [];
            //this.groupedCsvRows = [];

            ReportApi.generate(paramData)
            .then(response=>{
                let rows = [], csvRows = [];

                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.length > 0) {
                            
                            /** 1 VFE is 1 Row - Implementation */ 
                            let vcardsData = response.data;
                            let newVcardData = [];

                            if (vcardsData) {
                                // Loop through each validation card
                                vcardsData.forEach(vcard=>{
                                    vcard.vfeWithData = [];
                                    if (vcard.vfes) {
                                        // Loop through each vfe under that vcard
                                        // and get the answers for each vfe
                                        vcard.vfes.forEach(currVfe=>{
                                            let answers = [];
                                            answers = vcard.answers.filter(ans=>{
                                                return ans.vcardFormEntryIdFk == currVfe;
                                            }); 
                                            // Add those only with saved answers 
                                            if (answers.length > 0) {
                                                vcard.vfeWithData.push({
                                                    vfeId : currVfe,
                                                    reportingYear :  vcard.reportingYear,
                                                    reportingGroup : vcard.reportingGroup,
                                                    reportingEntity: vcard.reportingEntity,
                                                    reportingUnit : vcard.reportingUnit,
                                                    answers
                                                });
                                            }
                                        })
                                    }
                                    // Add vcards with vfe data only
                                    if (vcard.vfeWithData.length > 0) {
                                        newVcardData.push(vcard);
                                    }
                                });
                                // End: validation card loop

                                if (newVcardData.length > 0) {
                                    // Loop through each new validation card data
                                    newVcardData.forEach(vcardData=>{
                                        
                                        if (vcardData.vfeWithData.length > 0) {
                                            
                                            // Loop through each vfe of vcard
                                            vcardData.vfeWithData.forEach(vfeData=>{

                                                let rowCol = []; 

                                                let rowDataObj = {};

                                                this.selectedReportColumns.forEach((col,colIdx)=>{
                                                    if (col.valueType=='requiredField') {
                                                        if (col.value=='reportingYear') {
                                                            rowDataObj['reportingYear'] = vfeData.reportingYear;
                                                            rowCol.push(
                                                                {
                                                                    fieldName: "reportingYear",
                                                                    label: col.label,
                                                                    displayString : vfeData.reportingYear,
                                                                    value: vfeData.reportingYear,
                                                                    className: 'has-text-left'
                                                                }
                                                            );
                                                        }
                                                        else if (col.value=='reportingGroup') {
                                                            rowDataObj['reportingGroup'] = vfeData.reportingUnit ? vfeData.reportingUnit : vfeData.reportingEntity;
                                                            rowCol.push(
                                                                {
                                                                    fieldName: "reportingGroup",
                                                                    label: col.label,
                                                                    displayString : vfeData.reportingUnit ? vfeData.reportingUnit : vfeData.reportingEntity,
                                                                    value : vfeData.reportingUnit ? vfeData.reportingUnit : vfeData.reportingEntity,
                                                                    className: 'has-text-left'
                                                                }
                                                            );
                                                        }
                                                    }
                                                    else {


                                                        let ans = vfeData.answers.filter(ans=>{
                                                            return ans.fieldIdFk==col.value;
                                                        });

                                                        if (ans.length > 0) {
                                                            // Determine answer dispalyString using answerDataType
                                                            if (ans[0]) {
                                                                let useAnswer = "", className = "has-text-left";
                                                                switch(ans[0].answerDataType) {
                                                                    case "string" : 
                                                                        useAnswer = ans[0].answerTextValue;
                                                                        break;
                                                                    case "float" :
                                                                        /* Parse float */
                                                                        useAnswer = ans[0].answerDecimalValue;
                                                                        className = "has-text-right";
                                                                        break;
                                                                    case "integer" : 
                                                                        /* Parse int */
                                                                        useAnswer = ans[0].answerIntValue;
                                                                        className = "has-text-right";
                                                                        break;
                                                                    case "date": 
                                                                        /* To be parsed on the front-end */
                                                                        useAnswer = ans[0].answerDateValue;
                                                                        break;
                                                                }
                                                                rowDataObj['fieldId-'+col.value] = useAnswer;
                                                                rowCol.push(
                                                                    {
                                                                        fieldName: col.label,
                                                                        label: col.label,
                                                                        value: ans[0].answerDisplayString,
                                                                        answerValue : useAnswer,
                                                                        className
                                                                    }
                                                                );
                                                            }
                                                        }
                                                        else {
                                                            /** if vfe has no field, make it as empty column instead */
                                                            rowDataObj['fieldId-'+col.value] = '';
                                                            rowCol.push(
                                                                {
                                                                    fieldName: col.label,
                                                                    label: col.label,
                                                                    value: '',
                                                                    answerValue : '',
                                                                    className : ''
                                                                }
                                                            );
                                                        }

                                                    }
                                                });

                                                // Add vfe data as each row for 
                                                // UI table view
                                                rows.push(rowCol);

                                                // Add vfe data as each row for
                                                // CSV export feature
                                                csvRows.push(rowDataObj);
                                            });
                                            // End: loop through each vfe
                                        }
                                    });
                                    // End: new validation card data loop
                                }
                            }
                            /** End: 1 VFE is 1 Row Implementation */

                            /** Verify if grouping of data is applicable */
                            this.checkIfGroupingIsEnabled(rows,csvRows);
                        }      
                        else {
                            // No data
                            this.generatedRows = rows;
                            this.csvDataRows = csvRows;
                        }             
                    }
                    else {
                        this.promptServerError({response},'Report.generateCustomReport');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Report.generateCustomReport');
            });
        },
        selectRepGroup(grp) {
            if (this.selectedRepGroup==grp.repGroupId) {
                let repGroupData = {
                    label : "Agency/Company Name",
                    value: "reportingGroup",
                    valueType : "requiredField",
                    filterValue : grp.reportingGroup,
                    repGroupId : this.selectedRepGroup
                }
                if (!this.selectedReportColumns[1]) {
                    this.selectedReportColumns.push(repGroupData)
                }
                else {
                    this.selectedReportColumns[1] = repGroupData;
                }

                // Add to csv fields
                if (!this.csvFieldColumns[1]) {
                    this.csvFieldColumns.push('reportingGroup');
                }
                else {
                    this.csvFieldColumns[1] = 'reportingGroup';
                }

                // Add to csv field labels
                if (!this.csvFieldLabels.reportingGroup) {
                    this.csvFieldLabels.reportingGroup = '';
                }
                this.csvFieldLabels.reportingGroup = 'Agency/Company Name';
                this.csvFieldLabelsOpp['Agency/Company Name'] = 'reportingGroup';

            }
        },
        initColumns(){
            this.selectedReportColumns = [];

            this.selectedReportColumns.push({
                label : "Reporting Year",
                value : "reportingYear",
                filterValue : this.selectedReportingYear,
                valueType : "requiredField"
            });

            this.csvFieldColumns = [];
            this.csvFieldLabels = {};
            this.csvFieldLabelsOpp = {};

            // Add to csv fields
            this.csvFieldColumns.push('reportingYear');
            
            // Add to csv field labels
            this.csvFieldLabels.reportingYear = 'Reporting Year'
            this.csvFieldLabelsOpp['Reporting Year'] = 'reportingYear'
        },
        checkIfGroupingIsEnabled(rows,csvRows){
            let rowsPerCompany = [], 
                currCompany = "", 
                groupedRowInfo = [];

            this.isGroupingApplicable = false;

            if (rows.length == 0) {
                // Empty data
                this.generatedRows = [];
                this.csvDataRows = [];
                return false;
            }

            if (rows.length == 1) {
                // There's only 1 row;
                // Grouping is not needed
                this.generatedRows = rows;
                this.csvDataRows = csvRows;
                return false;
            }
            
            /** Get unique agencies/companies */
            rows.forEach(rData=>{
                if (rData.length > 0) {
                    if (currCompany!=rData[1].displayString) {
                        let currRdata = [];
                        if (rData.length > 0) {
                            rData.forEach(rd=>{
                                currRdata.push(rd)
                            });
                        }
                        rowsPerCompany.push(currRdata);                       
                    }         
                }                  
                currCompany = rData[1].displayString;
            });

            /** Get entries of agencies/companies */          
            rowsPerCompany.forEach(rowCol=>{
                if (rowCol.length > 0) {
                    // filter - those with same agency/company
                    let companyEntries = rows.filter(rData=>{
                        return (rData[1] && rData[1].displayString==rowCol[1].displayString)
                    });

                    let entriesColInfo = [{},{}];
                    rowCol.forEach((col,colIdx)=>{
                        if (colIdx > 1) {
                            let currColInfo = {
                                count : 0,
                                numCount : 0,
                                strCount : 0,
                                emptyCount : 0
                            };
                            if (companyEntries.length > 0) {
                                companyEntries.forEach(entryData=>{
                                    if (entryData.length > 0) {
                                        let sameCols = entryData.filter(ecol=>{
                                            return ecol.fieldName==col.fieldName;
                                        });
                                        if (sameCols.length > 0) {
                                            if (sameCols[0]) {
                                                if (sameCols[0].answerValue!='' &&
                                                    sameCols[0].value!='' &&
                                                    sameCols[0].answerValue!=null) {
                                                    if (typeof(sameCols[0].answerValue)=='string') {
                                                        currColInfo.strCount++;
                                                    }
                                                    else if (typeof(sameCols[0].answerValue)=='number') { 
                                                        currColInfo.numCount++;
                                                    }
                                                }
                                                else {
                                                    currColInfo.emptyCount++;
                                                }
                                                currColInfo.count++;
                                            }
                                        }
                                    }
                                });
                            }
                            entriesColInfo.push(currColInfo);
                        }
                    });
                    

                    groupedRowInfo.push({
                        agencyCompany : rowCol[1].displayString,
                        totalEntries : 0,
                        groupingApplicable : false,
                        companyEntries,
                        entriesColInfo,
                    });
                }
            });
            
            groupedRowInfo.forEach(data=>{
                if (data.companyEntries.length > 0) {
                    data.totalEntries = data.companyEntries.length;
                    if (data.entriesColInfo.length > 0) {
                        // check if there are string cols
                        let strCount = data.entriesColInfo.filter(colInfo=>{
                            return (colInfo.strCount>1);
                        });

                        let numMergeStrCount = data.entriesColInfo.filter(colInfo=>{
                            return (colInfo.strCount>0 && colInfo.numCount>0);
                        });

                        if (strCount.length > 0 || numMergeStrCount.length > 0) {
                            data.groupingApplicable = false;
                        }
                        else {
                            data.groupingApplicable = true;
                        }
                    }
                }
            });

            let countGroupingEnabled = groupedRowInfo.filter(data=>{
                return data.groupingApplicable==true;
            });

            if (countGroupingEnabled.length == groupedRowInfo.length) {
                this.isGroupingApplicable = true;
            }
            else {
                this.isGroupingApplicable = false;
            }

            /** Displayed rows and csv data */
            this.generatedRows = rows;
            this.csvDataRows = csvRows;
        },
        getGroupedData(rows,csvRows){
            /** Group displayed rows */
            let rowsPerCompany = [], currCompany = "";
            
            /** Get unique agencies/companies */
            rows.forEach(rData=>{
                if (rData.length > 0) {
                    if (currCompany!=rData[1].displayString) {
                        let currRdata = [];
                        if (rData.length > 0) {
                            rData.forEach(rd=>{
                                currRdata.push(rd)
                            });
                        }
                        rowsPerCompany.push(currRdata);                       
                    }         
                    else {
                        if (rowsPerCompany[rowsPerCompany.length-1] &&
                            rowsPerCompany[rowsPerCompany.length-1].length > 0) {                                            
                            /** 
                                * Loop each of the fields/columns of 
                                * existing agency/company and get columns without answers/values;
                                * 
                                * Then loop thru each of columns of current row data (rData),
                                * and check for the columns without answers 
                                * and map the answers accordingly, if there are answers
                                * */
                            rowsPerCompany[rowsPerCompany.length-1].forEach(r=>{  

                                /** Check columns without answers */                                       
                                if (r.answerValue=='' && r.value=='') {
                                    if (rData.length > 0) {
                                        /** Columns of current row */
                                        rData.forEach(cr=>{
                                            /** Get columns with answers */
                                            if (r.fieldName==cr.fieldName &&
                                                cr.answerValue!='' &&
                                                cr.value!='') {
                                                /** Map the answers to the newRow*/
                                                r.answerValue = cr.answerValue;
                                                r.value = cr.value;
                                            }
                                        })
                                    }
                                }
                                else {
                                    /** If original row has value already */
                                    /** Columns of current row */
                                    rData.forEach(cr=>{
                                        /** Get columns with answers */
                                        if (r.fieldName==cr.fieldName &&
                                            cr.answerValue!='' &&
                                            cr.value!='') {
                                            if (typeof(r.answerValue)=='string') {
                                                // Do nothing; don't merge
                                            }
                                            else if (typeof(r.answerValue)=='number') { 
                                                /** Map the answers to the newRow*/
                                                /** Add up answers */
                                                r.answerValue = r.answerValue + cr.answerValue;
                                                r.value = Number(r.answerValue).toLocaleString();
                                            }
                                        }
                                    })
                                }

                            });
                        }
                    }
                }                  
                currCompany = rData[1].displayString;
            });
            /** Assign new grouped rows */
            this.generatedRows = rowsPerCompany;
            /** End: Group displayed Rows */
            
            /** ----- */

            /** Group csv data */
            let csvRowsPerCompany = [], csvCurrCompany = "";
            csvRows.forEach(rData=>{
                if (rData) {
                    if (csvCurrCompany!=rData.reportingGroup) {
                        csvRowsPerCompany.push(rData);
                    }
                    else {
                        if (csvRowsPerCompany[csvRowsPerCompany.length-1]) {
                            for (let fieldAttr in csvRowsPerCompany[csvRowsPerCompany.length-1]) {

                                if (csvRowsPerCompany[csvRowsPerCompany.length-1][fieldAttr]=='' ||
                                    csvRowsPerCompany[csvRowsPerCompany.length-1][fieldAttr]==null)  {
                                    if (rData[fieldAttr]!='' && 
                                        rData[fieldAttr]!=null) {
                                        csvRowsPerCompany[csvRowsPerCompany.length-1][fieldAttr] = rData[fieldAttr];
                                    }
                                }
                                else {
                                    if (rData[fieldAttr]!='' && 
                                        rData[fieldAttr]!=null) {
                                        if (typeof(rData[fieldAttr])=='number' &&
                                            typeof(csvRowsPerCompany[csvRowsPerCompany.length-1][fieldAttr])=='number') {
                                            csvRowsPerCompany[csvRowsPerCompany.length-1][fieldAttr] = csvRowsPerCompany[csvRowsPerCompany.length-1][fieldAttr] + rData[fieldAttr];
                                        }
                                    }
                                }
                            }
                        }
                    }
                    csvCurrCompany = rData.reportingGroup;
                }
            });
            /** Assign new grouped csv data */
            this.csvDataRows = csvRowsPerCompany;
            /** End: Group csv data */
        },
        triggerGrouping(){
            if (this.isGrouped==false) {
                this.generateReport();
            }
            else {
                // Check restriction
                if (this.isGroupingApplicable==true) {
                    this.getGroupedData(this.generatedRows,this.csvDataRows);
                }                
            }
        },
        resetParameters(){
            this.selectedRepGroup = null;
            this.initColumns();
            this.generatedRows = [];
            this.csvDataRows = [];
            this.isGrouped = false;
            this.isGroupingApplicable = false;
        },
        saveAs(fileType) {
            switch(fileType) {
                case 'pdf':
                    this.downloadPdf();
                    break;
                case 'csv':
                    break;
                default:  
                    // excel sheet  
                    break;
            }
        },
        downloadPdf(){
            
            const _gray1_ = "#ababab"; // also field group label
            const _gray2_ = "#9b9b9b"; // <hr> color
            const _gray3_ = "#414042"; // dark gray

            var doc = new jsPDF({
                orientation: 'landscape'
            });

            // Generation details:
            doc.setFontStyle("normal");
            doc.setTextColor(_gray1_)
            doc.setFontSize(10)
            doc.text('Generated by ',15,22);
            doc.text(this.profile.fullName,50,22);

            doc.text('Date generated ',15,27);
            doc.text(this.$moment().format('lll'),50,27);

            doc.autoTable({
                theme: 'grid',
                headStyles : {
                    fillColor : [239, 235, 235],
                    textColor: [58, 58, 58],
                    lineColor: [158, 158, 158],
                    lineWidth: 0.1,
                    cellWidth: 'auto',
                    minCellWidth: 20,
                    valign: 'top'
                },
                columnStyles: {
                    0: {halign: 'left', cellWidth: 20},
                    1: {halign: 'left', cellWidth: 35}
                },
                startY: 34,
                pageBreak : 'avoid',
                rowPageBreak : 'avoid',
                html: '#generated-report-table'
            });

            var pageCount = doc.internal.getNumberOfPages();
            for(let i = 0; i < pageCount; i++) { 
                doc.setPage(i); 
                doc.setTextColor(_gray1_)
                doc.setFont("helvetica");
                doc.setFontSize(9);
                doc.text(15,192, FOOTER_TEXT+' | Page '+doc.internal.getCurrentPageInfo().pageNumber);
            }

            doc.save('ORE_Custom-Report_'+this.$moment().format('x')+'.pdf');
        
        },
        setVcardAsRow(){
            // Original implementation for generating report data
            // Each row is a validation card

            /** 1 Row is 1 Validation Card - Implementation */
            // let data = response.data;
            // data.forEach(vcard=>{
            //     let rowCol = []; 

            //     let rowDataObj = {};

            //     this.selectedReportColumns.forEach((col,colIdx)=>{
            //         if (col.valueType=='requiredField') {
            //             if (col.value=='reportingYear') {
            //                 rowDataObj['reportingYear'] = vcard.reportingYear;
            //                 rowCol.push(
            //                     {
            //                         fieldName: "reportingYear",
            //                         label: col.label,
            //                         displayString : vcard.reportingYear,
            //                         value: vcard.reportingYear
            //                     }
            //                 );
            //             }
            //             else if (col.value=='reportingGroup') {
            //                 rowDataObj['reportingGroup'] = vcard.reportingUnit ? vcard.reportingUnit : vcard.reportingEntity;
            //                 rowCol.push(
            //                     {
            //                         fieldName: "reportingGroup",
            //                         label: col.label,
            //                         displayString : vcard.reportingUnit ? vcard.reportingUnit : vcard.reportingEntity,
            //                         value : vcard.reportingUnit ? vcard.reportingUnit : vcard.reportingEntity
            //                     }
            //                 );
            //             }
            //         }
            //         else {
            //             let ans = vcard.answers.filter(ans=>{
            //                 return ans.fieldIdFk==col.value;
            //             });
            //             if (ans.length > 0) {
            //                 // Determine answer dispalyString using answerDataType
            //                 if (ans[0]) {
            //                     let useAnswer = "";
            //                     switch(ans[0].answerDataType) {
            //                         case "string" : 
            //                             useAnswer = ans[0].answerTextValue;
            //                             break;
            //                         case "float" :
            //                             /* Parse float */
            //                             useAnswer = ans[0].answerDecimalValue;
            //                             break;
            //                         case "integer" : 
            //                             /* Parse int */
            //                             useAnswer = ans[0].answerIntValue;
            //                             break;
            //                         case "date": 
            //                             /* To be parsed on the front-end */
            //                             useAnswer = ans[0].answerDateValue;
            //                             break;
            //                     }
            //                     rowDataObj['fieldId-'+col.value] = useAnswer;
            //                     rowCol.push(
            //                         {
            //                             fieldName: col.label,
            //                             label: col.label,
            //                             value: ans[0].answerDisplayString,
            //                             answerValue : useAnswer
            //                         }
            //                     );
            //                 }
            //             }
            //         }
            //     });

            //     // For table display
            //     rows.push(rowCol);

            //     // For export to csv
            //     csvRows.push(rowDataObj)
            // });
            /** End: 1 Row - 1 Validation Card - Implementation */ 
        },
        submitError(errorData,api){   
            let obj = {
                email : this.profile.email,
                username : this.profile.username,
                message : "["+errorData.type+" "+errorData.code+"] - "+errorData.message+" Request to: "+api,
                issueStatus : "Pending",
                issueType : "Issue",
                createdBy : this.profile.userId,
                pageName : this.$route.name,
                pageLink : this.$route.path
            };

            if (errorData.hasOwnProperty('query')) {
                obj.message += ' SQL Query: '+errorData.query;
            }

            // Add feedback/issue to DB
            IssueApi.add(obj)
            .then(response=>{
                if (response.data) {
                    if (response.data.issueId) {
                        this.$dialog.alert({
                            title: 'Success',
                            message: "<p><strong>Thanks for reporting!</strong></p><br/>  Admin will check this and get back to you, if necessary.",
                            type: 'is-success'
                        });
                    }
                    else {
                        this.$dialog.alert({
                            title: 'Error',
                            message: "Unable to submit error. Please try again later.",
                            type: 'is-danger'
                        });
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Issue.add');
            });
        },
        promptServerError(error,api){
            try {
                console.log(error)
                return false;
                let returnData = AppResourceUtil.getErrorData(error.response);
                if (returnData.errorData!=null) {
                    this.$dialog.confirm({
                        title: returnData.dialog.title,
                        message: returnData.dialog.message,
                        cancelText: "Close",
                        confirmText: "Submit Error",
                        type: 'is-danger',
                        onConfirm: () => {
                            this.submitError(returnData.errorData,api);
                        }
                    });
                }
            } 
            catch(respError){
                console.log(respError)
            }
        }
    }
}
</script>

<template>
    <section>
        <p class="subtitle page-title">Report</p>
        
        <section class="section no-padd--top app-view">
            
            <section class="base-box--loading"
                v-if="isLoading">
                <b-loading 
                    v-bind:is-full-page="false" 
                    v-bind:active.sync="isLoading" 
                    ></b-loading>
            </section>

            <div class="columns is-mobile"
                v-if="!isLoading">

                <!-- Column selection -->
                <div class="column is-3 report-cols-column">

                    <div class="box">

                        <div class="columns no-padd">
                            <div class="column">
                                <p class="subtitle is-6">Select Columns</p>
                            </div>
                            <div class="column no-padd has-text-right">
                                <!-- <button 
                                    class="button is-success"
                                    type="button"
                                    id="generate-btn"
                                    v-on:click="generateReport">
                                    Generate
                                </button> -->
                            </div>
                        </div>

                        <!-- 
                            Reporting year column:
                            This column is required in generating reports.
                            Only 1 reporting year is allowed at a time.
                        -->
                        <b-collapse
                            class="card"
                            v-bind:open="openRepYearLov == true"
                            v-on:open="openRepYearLov = false">

                            <div
                                slot="trigger"
                                slot-scope="props"
                                class="card-header"
                                role="button">
                                <p class="card-header-title">
                                    <b-checkbox
                                        value="true"
                                        disabled>Reporting Year</b-checkbox>
                                </p>
                                <a class="card-header-icon">
                                    <b-icon
                                        :icon="props.open ? 'menu-up' : 'menu-down'">
                                    </b-icon>
                                </a>
                            </div>
                            <div class="card-content">
                                <div class="content">

                                    <b-field
                                        class="text-caption"
                                        label="Select year">
                                        <b-select
                                            size="is-small"
                                            v-model="selectedReportingYear"
                                            v-on:change.native="selectYear">
                                            <option 
                                                v-for="(year,yearIdx) in reportingYearLov"
                                                v-bind:key="yearIdx"
                                                v-bind:value="year">
                                                {{year}}
                                            </option>
                                        </b-select>
                                    </b-field>

                                </div>
                            </div>
                        </b-collapse>

                        <!-- 
                            Reporting group column 
                            This column is required for now, in generating reports.
                            At least one of the two: Mining and Oil&Gas should be selected
                            Government Agencies is not part of this report;
                        -->
                        <b-collapse
                            class="card"
                            v-bind:open="openRepGroupsLov == true"
                            v-on:open="openRepGroupsLov = false">

                            <div
                                slot="trigger"
                                slot-scope="props"
                                class="card-header"
                                role="button">
                                <p class="card-header-title">
                                    Reporting Groups
                                </p>
                                <a class="card-header-icon">
                                    <b-icon
                                        :icon="props.open ? 'menu-up' : 'menu-down'">
                                    </b-icon>
                                </a>
                            </div>

                            <div class="card-content">
                                <div class="content">
                                    
                                    <b-field
                                        v-for="(grp,grpIdx) in companies"
                                        v-bind:key="grpIdx">
                                        <b-radio 
                                            v-model="selectedRepGroup"
                                            v-bind:native-value="grp.repGroupId"
                                            v-on:change.native="selectRepGroup(grp)"
                                            class="text-caption">
                                            {{grp.reportingGroup}}
                                        </b-radio>
                                        <!-- <b-checkbox
                                            v-model="grp.checked"
                                            v-on:change.native="addToColumns('reportingGroup',grp,grp.checked)">
                                            {{grp.reportingGroup}}
                                        </b-checkbox> -->
                                    </b-field>

                                    <!-- 
                                        Uncomment this if we want to filter a specific company or
                                        agency.

                                    <div class="column is-3 has-text-right">
                                        <a class="button is-light">
                                            <span>
                                                <i class="fas fa-filter"></i>
                                            </span>
                                        </a>
                                    </div> 
                                    -->

                                </div>
                            </div>
                        </b-collapse>

                    </div>

                    <div class="box"
                        v-if="selectedReportingYear && forms.length > 0 && selectedRepGroup ">

                        <p class="subtitle is-6">Forms/Fields</p>

                        <!-- 
                            Forms fields selection
                        -->
                        <ul
                            v-if="groupedForms.length > 0">

                            <li 
                                v-for="(grp,grpIdx) in groupedForms"
                                v-bind:key="grpIdx">

                                <!-- Form groupings  -->
                                <p class="subtitle is-6 form-group-name"
                                    v-if="grp.groupLabelName!=null && grp.filteredForms.length > 0">{{grp.groupLabelName}}</p>

                                <p class="subtitle is-6 form-group-name"
                                    v-if="grp.groupLabelName==null && grp.filteredForms.length > 0">Ungrouped</p>

                                <b-collapse
                                    class="card"
                                    v-for="(form,formIdx) in grp.filteredForms"
                                    v-bind:key="formIdx"
                                    v-bind:open="form.isOpen"
                                    v-on:open="form.isOpen=true">

                                    <div
                                        slot="trigger"
                                        slot-scope="props"
                                        class="card-header"
                                        role="button">

                                        <div class="columns card-header-col">

                                            <!-- Form name and access -->
                                            <div class="column">
                                                <p class="card-header-title text-caption">
                                                    {{form.formName}}
                                                </p>
                                                <div class="form-access-box">
                                                    <div class="tags">
                                                        <span class="tag text-caption"
                                                            v-for="(access,accessIdx) in form.formAccessData.reportingGroups"
                                                            v-bind:key="accessIdx"
                                                            v-bind:class="access.repGroupTagClass">
                                                            {{access.reportingGroup}}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="column is-2 has-text-right">
                                                <a class="card-header-icon">
                                                    <b-icon
                                                        :icon="props.open ? 'menu-up' : 'menu-down'">
                                                    </b-icon>
                                                </a>
                                            </div>
                                        </div>
                                        

                                    </div>

                                    <div class="card-content">
                                        <div class="content">
                                            <!-- Form fields -->

                                            <a class="button is-light text-caption is-small"
                                                @click="addAllFields(form)">
                                                Add All Fields
                                            </a>

                                            <div class="columns form-field-cols"
                                                v-for="(field,fieldIdx) in form.formFields"
                                                v-bind:key="fieldIdx">
                                                <div class="column has-text-left">
                                                    <span v-if="field.fieldGroupLabel"
                                                        class="text-caption">
                                                        {{field.fieldGroupLabel}} -
                                                    </span>
                                                    <span class="text-caption">
                                                        {{field.fieldLabel}}
                                                        {{field.fieldSubLabel}}
                                                    </span>
                                                </div>
                                                <div class="column is-2 has-text-right">
                                                    <a class="button is-small is-light"
                                                        v-on:click="addToColumns('formField',field,true)"
                                                        v-if="!inColumns('formField',field.fieldId)">
                                                        <i class="fas fa-plus"></i>
                                                    </a>
                                                    <a class="button is-small is-danger"
                                                        v-on:click="removeColumn('formField',field,false)"
                                                        v-if="inColumns('formField',field.fieldId)">
                                                        <i class="fas fa-minus"></i>
                                                    </a>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                </b-collapse>
                            </li>

                        </ul>

                        <div class="has-text-right gen-btn-content--btm">
                            <button 
                                class="button is-light"
                                type="button"
                                v-on:click="resetParameters"
                                v-bind:disabled="selectedReportColumns.length<2">
                                Reset
                            </button>
                            <button 
                                class="button is-success"
                                type="button"
                                v-on:click="generateReport"
                                v-bind:disabled="selectedReportColumns.length<2">
                                Generate
                            </button>
                        </div>

                    </div>

                </div>

                <!-- Report -->
                <div class="column">

                    <div class="columns">
                        <div class="column">
                            <div class="buttons has-text-left">
                                <button 
                                    v-bind:disabled="!(selectedReportingYear && selectedRepGroup && selectedReportColumns.length>2)"
                                    class="button is-success"
                                    type="button"
                                    v-on:click="generateReport">
                                    Generate
                                </button>

                                <button 
                                    v-bind:disabled="!(selectedReportingYear && selectedRepGroup && selectedReportColumns.length>2)"
                                    class="button is-light"
                                    type="button"
                                    v-on:click="resetParameters">
                                    Reset
                                </button>

                                &nbsp;&nbsp;
                                
                                <b-dropdown
                                    v-if="generatedRows.length > 0">
                                    <button type="button"
                                        class="button is-info"
                                        slot="trigger"
                                        role="button">
                                        <span>
                                            Save Report
                                        </span>
                                        <span class="icon">
                                            <i class="fas fa-file-download"></i>
                                        </span>
                                    </button>

                                    <b-dropdown-item
                                        v-if="csvFileName && 
                                            csvFieldColumns && 
                                            csvFieldLabels">
                                        
                                        <download-csv
                                            v-bind:data= "csvDataRows"
                                            v-bind:name="csvFileName+'.csv'"
                                            v-bind:fields="csvFieldColumns"
                                            v-bind:labels="csvFieldLabels"
                                            delimiter=",">
                                            .csv
                                        </download-csv>

                                    </b-dropdown-item>

                                    <b-dropdown-item
                                        v-if="csvFileName && csvFieldLabelsOpp">
                                        <download-excel
                                            v-bind:data= "csvDataRows"
                                            v-bind:fields="csvFieldLabelsOpp"
                                            v-bind:name="csvFileName+'.xls'"
                                            type="xls">
                                            .xls
                                        </download-excel>
                                    </b-dropdown-item>

                                    <b-dropdown-item
                                        v-on:click="saveAs('pdf')">
                                        .pdf
                                    </b-dropdown-item>

                                </b-dropdown>

                            </div>
                        </div>
                        <div class="column is-4 has-text-right">
                            <b-switch 
                                v-if="isGroupingApplicable"
                                v-model="isGrouped"
                                v-on:input="triggerGrouping">
                                Group by Agency/Company Name
                            </b-switch>
                        </div>
                    </div>
                                        

                    <div v-if="notRecommendedForPdf && generatedRows.length > 0"
                        class="warning-message">
                        <b-message type="is-warning">
                            There are {{selectedReportColumns.length}} columns selected. When saved as .pdf, some columns might be rendered beyond the margins.<br/> We <strong>recommend</strong> to save this data as <i>.csv</i> or <i>.xls</i> instead.
                        </b-message>
                    </div>

                    <div class="box">
                        <!-- <p class="subtitle">Preview</p> -->

                        <!-- Report Table -->
                        <div class="report-preview-box"
                            v-if="selectedReportingYear && selectedRepGroup && selectedReportColumns.length > 2">
                            
                            <table 
                                class="report-table-preview"
                                id="generated-report-table">
                                <thead>
                                    <tr>
                                        <th v-for="(col,colIdx) in selectedReportColumns"
                                            v-bind:key="colIdx">
                                            {{col.label}}
                                        </th>
                                    </tr>
                                </thead>

                                <!-- Answers -->
                                <tbody v-if="generatedRows.length > 0">
                                    <tr 
                                        v-for="(row,rowIdx) in generatedRows"
                                        v-bind:key="rowIdx"
                                        class="generated-rows">
                                        <td v-for="(rowCol,rowColIdx) in row"
                                            v-bind:key="rowColIdx"
                                            v-bind:class="rowCol.className">
                                            {{rowCol.value}}
                                        </td>
                                    </tr>
                                </tbody>
                                
                                <!-- No answers -->
                                <tbody v-if="generatedRows.length == 0">
                                    <tr class="no-data-row">
                                        <td 
                                            v-bind:colspan="selectedReportColumns.length"
                                            class="text-caption">
                                            No data generated.
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <span
                            class="text-caption" 
                            v-if="!(selectedReportingYear && selectedRepGroup && selectedReportColumns.length > 2)">
                            Please select reporting group and/or form fields.
                        </span>

                    </div>
                    
                </div>

            </div>
        </section>

    </section> 
</template>

<style scoped>
.no-padd--top.app-view {
    padding-top: 1rem !important;
}
.report-cols-column {
    max-height: 65vh;
    overflow-y: scroll;
}
.form-group-name {
    margin-top: 1.2rem;
}
.form-access-box {
    padding-left: 0.6rem;
    padding-bottom: 0.3rem;
}
.form-field-cols,
.card-header-col {
    padding:0px;
    width:100%;
    margin:0px;
    padding-bottom:0.6rem;
    margin-bottom:0em !important;
}
.form-field-cols > .column,
.card-header-col > .column {
    padding: 0px;
}
.form-field-cols > .column:first-child {
    padding-left: 1rem;
}
.form-field-cols:not(:last-child) {
    border-bottom: 1px dotted #efefef;
    margin-top: 0.7rem;
}

.report-table-preview {
    border-collapse: collapse;
    border:1px solid #e5e5e5;
}
.report-table-preview th {
    padding: 1rem;
    border:1px solid #e5e5e5;
}
.report-preview-box {
    padding-right: 1rem;
    max-width:930px;
    overflow-x:scroll;
}
.report-preview-box table {
    margin-right: 1rem;
}
#generate-btn {
    margin-top:0.4rem;
    margin-right: 0.6rem;
}
.gen-btn-content--btm {
    padding-top: 0.6rem;
}

.generated-rows td {
    padding: 0.4rem;
    border:1px solid #e5e5e5;
}
.no-data-row td {
    text-align: left;
    padding: 0.4rem;
}
/*MBP*/
@media screen and (min-width: 1024px) and (max-width: 1439px) { 
	.report-preview-box {
        max-width: 875px;
    }
}
/*Surface*/
@media screen and (min-width: 1440px) and (max-width: 1535px){ 
	
}
/*Widescreen*/
@media screen and (min-width: 1536px) and (max-width: 1600px) {
}
.warning-message {
    margin-bottom: 1em;
}
</style>



// WEBPACK FOOTER //
// src/views/reporting/ReportsView.vue